import { State } from '.';
import { EncounterRxReconcile } from '../../models/encounter-rx-reconcile';

export const selectors = {
    getEncounterRxReconcile: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<EncounterRxReconcile> => state.byId[id || ''],
    getEncounterRxReconcileHash: (
        state: State
    ): Dictionary<EncounterRxReconcile> => state.byId,
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false
};
